import { render, staticRenderFns } from "./ClickAssistant.vue?vue&type=template&id=df180ac2&scoped=true&"
import script from "./ClickAssistant.vue?vue&type=script&lang=js&"
export * from "./ClickAssistant.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df180ac2",
  null
  
)

export default component.exports